import classes from "./StatTag.module.css";

const StatTag = (props) => {
  return (
    <div className={`${classes.wrapper} ${classes[`${props.style.bg}`]}`}></div>
  );
};

export default StatTag;
